import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Podcast from '../entities/podcast'
import MediaItem from '../entities/mediaItem'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'

interface PodcastState extends ListState<Podcast>{
    podcast:Podcast,
    mediaitems:Array<MediaItem>,
    podcastsMediaitems:Array<MediaItem>,
}
class PostMutations extends ListMutations<Podcast>{

}
class PodcastsModule extends ListModule<PodcastState,any,Podcast>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Podcast>(),
        mediaitems: new Array<MediaItem>(),
        podcastsMediaItems:new Array<MediaItem>(),
        loading:true,
        podcast:new Podcast(),
    }
    actions={
        async getAll(context:ActionContext<PodcastState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Podcast/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Podcast>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<PodcastState,any>,payload:any){
            await Ajax.post('/api/services/app/Podcast/Create',payload.data);
        },
        async update(context:ActionContext<PodcastState,any>,payload:any){
            await Ajax.put('/api/services/app/Podcast/Update',payload.data);
        },
        async addPodcastItem(context:ActionContext<PodcastState,any>,payload:any){
            context.state.loading=true;
            await Ajax.post('/api/services/app/Podcast/AddPodcastItem',payload.data).then( (result) =>{
                context.state.loading=false;
            }
            );           
        },
        async delete(context:ActionContext<PodcastState,any>,payload:any){
            context.state.loading=true;
            await Ajax.delete('/api/services/app/Podcast/Delete?Id='+payload.data.id);
            context.state.loading=false;
        },
        async get(context:ActionContext<PodcastState,any>,payload:any){
            let response=await Ajax.get('/api/services/app/Podcast/Get?Id='+payload.data.Id);
            let responsePodcast=await Ajax.get('/api/services/app/Podcast/GetPodcastMediaItems?Id='+payload.data.Id);
            var podcast = response.data.result;
            podcast.podcastsMediaItems = responsePodcast.data.result;
            return podcast as Podcast;
        },
        async getAllMediaItems(context:ActionContext<PodcastState,any>){
            let reponse=await Ajax.get('/api/services/app/MediaItems/GetAll');
            context.state.mediaitems=reponse.data.result.items;
        }, 
        async getPodcastsMediaItems(context:ActionContext<PodcastState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Podcast/GetPodcastMediaItems?Id='+payload.data.id);
            context.state.podcast.podcastsMediaItems = reponse.data.result;
            return reponse.data.result;
        },        
        async getUPodcastMediaItem(context:ActionContext<PodcastState,any>,payload:any){
            context.state.loading=true;
            await Ajax.get('/api/services/app/Podcast/GetUPodcastMediaItem',{params:payload.data});
            context.state.loading=false;
        },
        async up(context:ActionContext<PodcastState,any>,payload:any){
            await Ajax.post('/api/services/app/Podcast/Up',payload.data);
        },
        async down(context:ActionContext<PodcastState,any>,payload:any){
            await Ajax.post('/api/services/app/Podcast/Down',payload.data);
        },  
        async mediaUp(context:ActionContext<PodcastState,any>,payload:any){
            await Ajax.post('/api/services/app/Podcast/MediaUp?MediaItemId='+payload.data.mediaItemId+'&PodcastId='+payload.data.podcastId);
        },
        async mediaDown(context:ActionContext<PodcastState,any>,payload:any){
            await Ajax.post('/api/services/app/Podcast/MediaDown?MediaItemId='+payload.data.mediaItemId+'&PodcastId='+payload.data.podcastId);
        },       
    };
    mutations={
        setCurrentPage(state:PodcastState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:PodcastState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:PodcastState,podcast:Podcast){
            state.podcast=podcast;
        },
        setLoading(state:PodcastState,loading:boolean){
            state.loading=loading;
        }
    }
}
const module=new PodcastsModule();
export default module;